import {extendVariants, Select} from "@heroui/react";

const PSelect = extendVariants(Select, {
    defaultVariants: {
        placeholder:    ' ',
        radius:         "sm",
        labelPlacement: "outside",
    },
});

export default PSelect;
